module.exports = __webpack_public_path__ + "static/img/in one city inn.bf5d6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/in one city inn.png?20181011
// module id = zJcu
// module chunks = 1